<script>
	export let label="label"
	export let value=""
	export let data=[]
	// export let readonly=false

	$: viewLabel = () => value!==""
	
</script>

<span >
	<label for="">{@html viewLabel() ? label : '&nbsp;'}</label>
	<select bind:value={value} on:blur>
		<option value="" disabled>Elegir</option>
		{#each data as item, index}
			<option value={item}>{item}</option>
		{/each}
	</select>
</span>

<style>
	span{display: flex;flex-flow: column;}
	span>label{font-size: 0.7em;color:#555555;padding-bottom:0.5px;}
	select{margin-top:0;padding-top:4px;padding-bottom:4px;}
</style>